import type { Element } from "React";
import { Component } from "react";
import { FormattedMessage } from "react-intl";
import type { EventType } from "../../../../../../../../../../../types/eventType";
import "./CorrectScoreMarketTypeSubheading.scss";
type Props = {
  event: EventType;
};

class CorrectScoreMarketTypeSubheading extends Component<Props> {
  render(): Element<"div"> {
    const { event } = this.props;
    return (
      <div className={"subheading correct-score"}>
        <span key={"participant1" + event.id + event.participant1}>
          {event.participant1}
        </span>
        <span key={"draw" + 2}>
          <FormattedMessage id="events-draw" tagName="span" />
        </span>

        <span key={"participant2" + event.id + event.participant2}>
          {event.participant2}
        </span>
      </div>
    );
  }
}

export default CorrectScoreMarketTypeSubheading;
